import { trpc } from '../../../../App'

export function useUpdateAkteMutation() {
  const trpcCtx = trpc.useUtils()
  return trpc.akte.update.useMutation({
    onSuccess: (updatedAkte, variables) => {
      const { id } = updatedAkte
      const updatedFields = Object.fromEntries(
        Object.entries(variables).filter(([fieldName]) => fieldName !== 'id')
      ) as Partial<typeof updatedAkte>

      trpcCtx.akte.byId.setData({ id }, (previousAkte) => {
        if (previousAkte == undefined) {
          return updatedAkte
        }

        return {
          ...previousAkte,
          ...updatedFields,
          ...updatedAkte,
          id,
          creationData: updatedAkte.creationData,
          projectStatus: updatedAkte.projectStatus,
          progress: updatedAkte.progress,
          handoverState: updatedAkte.handoverState,
          PDB_Projektart: updatedAkte.PDB_Projektart,
        }
      })
      trpcCtx.akte.getAll.invalidate()
      trpcCtx.akte.projectNotificationList.invalidate({ id })
      trpcCtx.audit.invalidate({ entryId: id, entryType: 'akte' })
      trpcCtx.userData.userNotificationList.invalidate()
    },
  })
}
